const getUnsavedChanges = state => routeName => {
    return state.unsaved_changes[routeName] ? state.unsaved_changes[routeName] : [];
};

export default {
    getUnsavedChanges,
};
